import { Component, OnInit } from '@angular/core';
import timeGridPlugin from '@fullcalendar/timegrid';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-today-commitments',
  templateUrl: './today-commitments.component.html',
  styleUrls: ['./today-commitments.component.css']
})
export class TodayCommitmentsComponent implements OnInit {

  constructor(
  	public translations: TranslationService
  ) { }

  ngOnInit() {
  }

  todayCommitments = [timeGridPlugin];

}
